module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [(_vm.isBackbtnSlotExists) ? _vm._t("backbtn") : _c('router-link', {
    staticClass: "top__link",
    attrs: {
      "to": {
        name: "profile-education"
      }
    }
  }, [_vm._v("Назад")]), _c('Header', {
    attrs: {
      "title": _vm.title,
      "subtitle": _vm.subtitle
    }
  }, [_vm._t("filter", null, {
    "slot": "selector"
  })], 2), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ede4c9c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/components/top/Top.vue
// module id = 42279c6fc2d02b07e52b
// module chunks = 0